<mat-form-field mat-input-height-large-label>
  <mat-label>{{ vddName }}</mat-label>
  <input
    data-at-remote-diagnostics-edit-value="vin"
    gtm="onTextField"
    gtmAction="Vdd vin edit value"
    gtmCategory="diagnosticsPage"
    [gtmOn]="['change', 'focus', 'blur']"
    matInput
    type="text"
    [formControl]="vinFormControl"
    (change)="valueChange($event)"
  />
  <mat-error *ngIf="vinFormControl.getError('pattern')">
    {{ 'DIAGNOSTICS.VIN_EDIT.VALIDATION_PATTERN' | translate }}
  </mat-error>
  <mat-error *ngIf="vinFormControl.getError('minlength') || vinFormControl.getError('maxlength')">
    {{ 'DIAGNOSTICS.VIN_EDIT.VALIDATION' | translate }}
  </mat-error>
</mat-form-field>
